export default "__VITE_ASSET__D5BIiGpE__"